import {
  IconIdBadge2,
  IconMapPin,
  IconUser,
  IconCake,
  IconClock,
  IconBusinessplan,
  IconClipboardCheck,
} from "@tabler/icons-react";
import Card from "./Card";
import styles from "../TalentProfile.module.css";
import moment from "moment";
import { currencyFormat } from "../../../../utils/functions";

function DetailRow({ icon: Icon, label, children }) {
  return (
    <div className={styles.detailRow}>
      <span className={styles.detailLabel}>
        <Icon size={16} /> {label}
      </span>
      <span className={styles.detailValue}>{children}</span>
    </div>
  );
}

const OverviewCard = ({ talent, hidden }) => {
  return (
    <Card icon={IconIdBadge2} title="Overview">
      <DetailRow icon={IconMapPin} label="Location">
        {talent?.currentLocation}
      </DetailRow>
      <DetailRow icon={IconUser} label="Gender">
        {talent?.gender}
      </DetailRow>
      <DetailRow icon={IconCake} label="Age">
        {moment().diff(moment(talent?.dateOfBirth), "years")} years
      </DetailRow>
      <DetailRow icon={IconBusinessplan} label="Expected pay">
        &#8358;
        {currencyFormat(Number(talent?.desiredCompensation?.lowestAmount ?? 0))}{" "}
        - &#8358;
        {currencyFormat(
          Number(talent?.desiredCompensation?.highestAmount ?? 0),
        )}
      </DetailRow>
      <DetailRow icon={IconClipboardCheck} label="Psychometric">
        {hidden ? (
          <span className={styles.hidden}>Hidden by talent</span>
        ) : (
          <span className={styles.ok}>Verified</span>
        )}
      </DetailRow>
    </Card>
  );
};

export default OverviewCard;
